import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const contractJson = require('./vipPoolContract.json')

let web3 = $web3js.getWeb3();
let contractAddress = $bizConfig.vipPoolContractAddress;
let contractConst = {
  contract: web3 ? new web3.eth.Contract(contractJson.abi, contractAddress) : '',
}

const getVipPoolAddress = () => {
  return contractAddress;
}

const getVipPoolContract = () => {
  return contractConst.contract;
}

const vipPoolUserDeposit = async ([_pid, _amount, _contractAddress], options, callback) => {
  _pid = $web3js.stringToBytes32(_pid);
  _amount = await $erc20.toErc20Value(_amount, _contractAddress);
  return $web3js.send(getVipPoolContract().methods.userDeposit, [_pid, _amount], options, callback);
}

const vipPoolUserDepositEstimateSend = async ([_pid, _amount, _contractAddress], options) => {
  _pid = $web3js.stringToBytes32(_pid);
  _amount = await $erc20.toErc20Value(_amount, _contractAddress);

  let gasPromise = $web3js.estimateSend(getVipPoolContract().methods.userDeposit, [_pid], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

const vipPoolUserRedeem = async ([_pid, _amount, _contractAddress], options, callback) => {
  _pid = $web3js.stringToBytes32(_pid);
  _amount = await $erc20.toErc20Value(_amount, _contractAddress);

  let dmcMiningContractAddress = $bizConfig.dmcMiningContractAddress;
  if (!!dmcMiningContractAddress) {
    return $web3js.send(getVipPoolContract().methods.userRedeemV2, [dmcMiningContractAddress, _pid, _amount], options, callback);
  }
  return $web3js.send(getVipPoolContract().methods.userRedeem, [_pid, _amount], options, callback);
}

const vipPoolUserRedeemEstimateSend = async ([_pid, _amount, _contractAddress], options) => {
  _pid = $web3js.stringToBytes32(_pid);
  _amount = await $erc20.toErc20Value(_amount, _contractAddress);
  let dmcMiningContractAddress = $bizConfig.dmcMiningContractAddress;

  let gasPromise;
  if (!!dmcMiningContractAddress) {
    gasPromise = $web3js.estimateSend(getVipPoolContract().methods.userRedeemV2, [dmcMiningContractAddress, _pid, _amount], options);
  } else {
    gasPromise = $web3js.estimateSend(getVipPoolContract().methods.userRedeem, [_pid, _amount], options);
  }
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

const vipPoolUserIncome = ([_pid], options, callback) => {
  _pid = $web3js.stringToBytes32(_pid);
  return $web3js.send(getVipPoolContract().methods.userIncome, [_pid], options, callback);
}

const vipPoolUserIncomeEstimateSend = async ([_pid], options) => {
  _pid = $web3js.stringToBytes32(_pid);

  let gasPromise = $web3js.estimateSend(getVipPoolContract().methods.userIncome, [_pid], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

const vipPoolVendorWithdraw = ([_pid], options, callback) => {
  _pid = $web3js.stringToBytes32(_pid);
  return $web3js.send(getVipPoolContract().methods.vendorWithdraw, [_pid], options, callback);
}

const vipPoolVendorWithdrawEstimateSend = async ([_pid], options) => {
  _pid = $web3js.stringToBytes32(_pid);

  let gasPromise = $web3js.estimateSend(getVipPoolContract().methods.vendorWithdraw, [_pid], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

const getVipPoolInfo = ([_pid, ptoken, dli], options) => {
  _pid = $web3js.stringToBytes32(_pid);
  return $web3js.call(getVipPoolContract().methods.getMiningPoolInfo, [_pid], options, handlePoolInfo, [ptoken, dli]);
}

const handlePoolInfo = async (res, ptoken, dli) => {
  // console.log(res)
  let index = 0;
  let totalPrincipalAmount = res[index++];
  let totalBenefitAmount = res[index++];
  let totalDmcBenefitAmount = res[index++];
  let principalLiquidAmount = res[index++];
  let benefitLiquidAmount = res[index++];
  let principalExchangeAmount = res[index++];
  let benefitExchangeAmount = res[index++];
  let dmcBenefitExchangeAmount = res[index++];
  let dpPrice = res[index++];
  let dmcPledgeRatio = res[index++];
  let userTotalPledgeDmc = res[index++];
  let userTotalRedeemDmc = res[index++];

  totalPrincipalAmount = await $erc20.fromErc20Value(totalPrincipalAmount, ptoken);
  totalBenefitAmount = await $erc20.fromErc20Value(totalBenefitAmount, dli);
  totalDmcBenefitAmount = await $erc20.fromErc20Value(totalDmcBenefitAmount, dli);
  principalLiquidAmount = await $erc20.fromErc20Value(principalLiquidAmount, ptoken);
  benefitLiquidAmount = await $erc20.fromErc20Value(benefitLiquidAmount, dli);
  principalExchangeAmount = await $erc20.fromErc20Value(principalExchangeAmount, ptoken);
  benefitExchangeAmount = await $erc20.fromErc20Value(benefitExchangeAmount, dli);
  dmcBenefitExchangeAmount = await $erc20.fromErc20Value(dmcBenefitExchangeAmount, dli);
  dpPrice = Vue.prototype.$numberUtils.movePointLeft(dpPrice, 18);
  userTotalPledgeDmc = Vue.prototype.$numberUtils.movePointLeft(userTotalPledgeDmc, 18);
  userTotalRedeemDmc = Vue.prototype.$numberUtils.movePointLeft(userTotalRedeemDmc, 18);

  return {
    totalPrincipalAmount,
    totalBenefitAmount,
    totalDmcBenefitAmount,
    principalLiquidAmount,
    benefitLiquidAmount,
    principalExchangeAmount,
    benefitExchangeAmount,
    dmcBenefitExchangeAmount,
    dpPrice,
    dmcPledgeRatio,
    userTotalPledgeDmc,
    userTotalRedeemDmc,
  }
}

const getVipPoolGlobalInfo = ([_pid], options) => {
  return $web3js.call(getVipPoolContract().methods.getGlobalInfo, [_pid], options, handlePoolGlobalInfo);
}

const handlePoolGlobalInfo = async (res) => {
  // console.log(res)
  let index = 0;
  let ptoken = res[index++];
  let afil = res[index++];
  let dlp = res[index++];
  let dli = res[index++];
  let dlpDmc = res[index++];
  let dpPrice = res[index++];
  let dmcDpPrice = res[index++];
  let dmcPledgeRatio = res[index++];
  let userTotalPledgeDmc = res[index++];
  let userTotalRedeemDmc = res[index++];
  let userDeposits = res[index++];
  let userGainPrincipals = res[index++];
  let userGainBenefits = res[index++];
  let userGainDmcBenefits = res[index++];
  let plateformBenefits = res[index++];
  let vendorGains = res[index++];
  let vendorReleasePrincipals = res[index++];
  let vendorReleaseBenefits = res[index++];
  let vendorReleaseDmcBenefits = res[index++];
  let state = res[index++];
  let active = res[index++];

  userDeposits = await $erc20.fromErc20Value(userDeposits, ptoken);
  userGainPrincipals = await $erc20.fromErc20Value(userGainPrincipals, ptoken);
  userGainBenefits = await $erc20.fromErc20Value(userGainBenefits, dli);
  userGainDmcBenefits = await $erc20.fromErc20Value(userGainDmcBenefits, dli);
  plateformBenefits = await $erc20.fromErc20Value(plateformBenefits, dli);
  vendorGains = await $erc20.fromErc20Value(vendorGains, ptoken);
  vendorReleasePrincipals = await $erc20.fromErc20Value(vendorReleasePrincipals, ptoken);
  vendorReleaseBenefits = await $erc20.fromErc20Value(vendorReleaseBenefits, dli);
  vendorReleaseDmcBenefits = await $erc20.fromErc20Value(vendorReleaseDmcBenefits, dli);

  userTotalPledgeDmc = Vue.prototype.$numberUtils.movePointLeft(userTotalPledgeDmc, 18);
  userTotalRedeemDmc = Vue.prototype.$numberUtils.movePointLeft(userTotalRedeemDmc, 18);
  dpPrice = Vue.prototype.$numberUtils.movePointLeft(dpPrice, 18);

  return {
    ptoken,
    afil,
    dlp,
    dli,
    dlpDmc,
    dpPrice,
    dmcDpPrice,
    dmcPledgeRatio,
    userTotalPledgeDmc,
    userTotalRedeemDmc,
    userDeposits,
    userGainPrincipals,
    userGainBenefits,
    userGainDmcBenefits,
    plateformBenefits,
    vendorGains,
    vendorReleasePrincipals,
    vendorReleaseBenefits,
    vendorReleaseDmcBenefits,
    state,
    active,
  }
}

const getVipPoolUserIncome = ([_pid], options) => {
  return $web3js.call(getVipPoolContract().methods.getUserTotalIncome, [_pid], options, $web3js.fromWei);
}

const getVipPoolMinDeposits = ([_pid], options) => {
  return $web3js.call(getVipPoolContract().methods.getPoolParamCfg, [_pid], options, handlePoolParamCfg);
}

const handlePoolParamCfg = async (res) => {
  let index = 0;
  let minDepositNum = res[index++];
  let liquidPercentage = res[index++];

  minDepositNum = Vue.prototype.$numberUtils.movePointLeft(minDepositNum, 18);

  return {
    minDepositNum,
    liquidPercentage
  }
}

const getVipPoolRemainDeposits = ([_pid], options) => {
  return $web3js.call(getVipPoolContract().methods.getPoolRemainDeposits, [_pid], options, $web3js.fromWei);
}

export default {
  getVipPoolAddress,
  getVipPoolContract,
  vipPoolUserDeposit,
  vipPoolUserDepositEstimateSend,
  vipPoolUserRedeem,
  vipPoolUserRedeemEstimateSend,
  vipPoolUserIncome,
  vipPoolUserIncomeEstimateSend,
  vipPoolVendorWithdraw,
  vipPoolVendorWithdrawEstimateSend,
  getVipPoolInfo,
  getVipPoolGlobalInfo,
  getVipPoolUserIncome,
  getVipPoolMinDeposits,
  getVipPoolRemainDeposits,
}


// WEBPACK FOOTER //
// ./src/lib/contract/vipPool/index.js